module.exports = __webpack_public_path__ + "annualreview2017/static/img/journey-logo-1@2x.096f90b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/journey-logo-1@2x.png
// module id = 311
// module chunks = 0